import {
  useFloating,
  offset,
  flip,
  shift,
  autoUpdate,
  useDismiss,
  useInteractions,
  useClick,
  FloatingFocusManager,
  useRole,
} from '@floating-ui/react';

import cn from 'clsx';
import styles from './Dropdown.module.scss';

import { useState } from 'react';

const Dropdown = ({
  buttonClassName,
  buttonDesign = 'dark',
  buttonContent,
  children,
  middleware = [],
  count,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const { refs, floatingStyles, context } = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    placement: 'bottom-start',
    middleware: [
      offset({ crossAxis: 0, mainAxis: 5 }),
      flip(),
      shift(),
      ...middleware,
    ],
    whileElementsMounted: autoUpdate,
  });

  const click = useClick(context);

  const dismiss = useDismiss(context);

  const role = useRole(context);

  const { getReferenceProps, getFloatingProps } = useInteractions([
    dismiss,
    click,
    role,
  ]);

  return (
    <>
      <button
        className={cn(styles.button, styles[buttonDesign], buttonClassName)}
        ref={refs.setReference}
        {...getReferenceProps()}
      >
        {buttonContent}
        {count > 0 && <div className={styles.count}>{count}</div>}
      </button>

      {isOpen && (
        <FloatingFocusManager context={context} modal={false}>
          <div
            className={styles.content}
            ref={refs.setFloating}
            style={{
              ...floatingStyles,
            }}
            {...getFloatingProps()}
          >
            {children}
          </div>
        </FloatingFocusManager>
      )}
    </>
  );
};

export default Dropdown;
